import axios from "axios";
const API_BASE_URL = "https://bardawamplus.com/api";
export const fetchAnalyticsData = async () => {
  try {
    const res = await axios.get(`${API_BASE_URL}/analytics`);
    return res.data;
  } catch (error) {
    console.error("Error fetching analytics data:", error);
    throw error;
  }
};
export const fetchPinnedProducts = async () => {
  try {
    const res = await axios.get(`${API_BASE_URL}/products/pinned`);
    return res.data;
  } catch (error) {
    console.error("Error fetching pinned products:", error);
    throw error;
  }
};
export const fetchAllProducts = async () => {
  try {
    const res = await axios.get(`${API_BASE_URL}/products`);
    return res.data;
  } catch (error) {
    console.error("Error fetching all products:", error);
    throw error;
  }
};
